import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'app-toggl-test',
    templateUrl: './toggl-test.component.html',
    styleUrls: ['./toggl-test.component.scss']
})
export class TogglTestComponent {
    constructor(private route: ActivatedRoute,
        private router: Router) {}
    // Component logic goes here
}